module.exports = __webpack_public_path__ + "static/media/top_19.ab766e8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/images/top_19.svg
// module id = 245
// module chunks = 27